import React from 'react';
import { AcademiaComparison } from './components/AcademiaComparison';
import { Bonuses } from './components/Bonuses';
import { Faq } from './components/Faq';
import { FloatingElements } from './components/Floating';
import { Footer } from './components/Footer';
import { FullTestimonials } from './components/FullTestimonials';
import { GuaranteeAndCost } from './components/GuaranteeAndCost';
import { Hero } from './components/Hero';
import { MetaPixel } from './components/MetaPixel';
import { PainAndTransformation } from './components/PainAndTransformation';
import { Pricing } from './components/Pricing';
import { ProductOverview } from './components/ProductOverview';
import { Testimonials } from './components/Testimonials';
import { TopBar } from './components/TopBar';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-ink text-zinc-400 selection:bg-gold selection:text-ink" data-id="element-0" data-mp="28tmfp53igeya">
      <MetaPixel data-id="element-1" data-mp="23ujk0b9f7l2z" />
      <TopBar data-id="element-2" data-mp="23v2s7099qv3t" />
      <main data-id="element-3" data-mp="23t8eo70bu59r">
        <Hero data-id="element-4" data-mp="3ijxnsm94vshs" />
        <Testimonials data-id="element-5" data-mp="3ikh8ubu2yx01" />
        <PainAndTransformation data-id="element-6" data-mp="3iiwfuqnezm4a" />
        <ProductOverview data-id="element-7" data-mp="3ihv1odb3qjic" />
        <Bonuses data-id="element-8" data-mp="3mlj6wpc9h30f" />
        <Pricing data-id="element-9" data-mp="3ml17xky7saot" />
        <AcademiaComparison data-id="element-10" data-mp="3mkhou0wtvg97" />
        <FullTestimonials data-id="element-11" data-mp="3mjpyp5m02aqb" />
        <Pricing id="oferta-final" data-id="element-12" data-mp="3rc9hqi3ghy2i" />
        <Faq data-id="element-13" data-mp="3rdar8i4tqci4" />
        <GuaranteeAndCost data-id="element-14" data-mp="3rcsyhvhdegey" />
      </main>
      <Footer data-id="element-15" data-mp="5yj0slx59ec" />
      <FloatingElements data-id="element-16" data-mp="6hqtghuuhen" />
      <noscript data-id="element-17" data-mp="4ww9qvjiygs">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=3123699361155808&ev=PageView&noscript=1" alt="" data-id="element-18" data-mp="5ghbgghm2z1" />
      </noscript>
    </div>;
}